<template>
  <div class="app-loader"></div>
</template>

<script>
export default {
  name: 'AppLoader',
};
</script>

<style lang="scss" scoped>
@import "app-loader";
</style>
